import { render, staticRenderFns } from "./flow-chart.vue?vue&type=template&id=3aadd9d2&scoped=true&"
import script from "./flow-chart.vue?vue&type=script&lang=js&"
export * from "./flow-chart.vue?vue&type=script&lang=js&"
import style0 from "./flow-chart.vue?vue&type=style&index=0&id=3aadd9d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aadd9d2",
  null
  
)

export default component.exports